export default __webpack_public_path__ + "navigation-examples-advanced-thumbnail-v1-480-8367ed8fc9774813b2ff4bf90260c7d4.png";